const DASH = '—'

// One catalog value as a staff cell shows it. t is the kind: no (not in the
// plan), inc (included), lim (a limit of v), met (v included, then metered;
// unit says what), cus (set by contract, v the default), add (an add-on).
export const valueText = (value, unit) => {
  if (!value) return DASH
  const n = value.v === null || value.v === undefined ? null : value.v
  switch (value.t) {
    case 'inc': return 'Included'
    case 'lim': return n === null ? DASH : String(n)
    case 'met': return n === null ? 'Included' : `${n}${unit ? ` ${unit}` : ''} included`
    case 'cus': return n === null ? 'Contract' : `Contract (${n})`
    case 'add': return 'Add-on'
    default: return DASH
  }
}

export const isHidden = plan => Boolean(plan) && plan.visibility === 'hidden'

// Plan keys in display order: the visible plans by their order, then the
// hidden ones by theirs (key breaks a tie, so the order never wobbles).
export const planOrder = plans => {
  const keys = Object.keys(plans || {})
  const by = (a, b) => (plans[a].order - plans[b].order) || a.localeCompare(b)
  return [...keys.filter(k => !isHidden(plans[k])).sort(by), ...keys.filter(k => isHidden(plans[k])).sort(by)]
}

// A limit or an included amount as an entitlements cell shows it.
export const numberText = n => (n === null || n === undefined ? DASH : String(n))
